import PropTypes from 'prop-types';
import {
  Form,
  FormField,
  SubmitButton,
} from '@codev/helix-react';
import React from 'react';
import {
  Col,
  FormControl,
  Grid,
  Row,
  ButtonToolbar,
  Button,
} from 'react-bootstrap';
import Panel from '../Panel.jsx';
import Captcha from '../Captcha.jsx';
import createLoginLink from './createLoginLink.js';
import styles from './UsernameForm.css';
import window from '../globalWrappers/window.js';
import browserIsIE from '../utilities/browserIsIE.js';

class UsernameForm extends React.Component {

  handleRecaptcha = () => {
    window.grecaptcha.execute();
  }

  render() {
    let {
      onChange,
      onSubmit,
      username,
      captchaSiteKey
    } = this.props;
    return (
      <Form
        method="POST"
        onSubmit={this.handleRecaptcha}
      >
        <Panel>
          <Grid
            fluid
            style={{
              marginRight: '-20px',
              width: browserIsIE() ? '100%' : null,
            }}>
            <Row>
              <Col xs={12}>
                <div className={styles.info}>
                  Please provide your admin username and we&apos;ll walk you through resetting your password.
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <FormField
                  className={`required ${styles.usernameForm}`}
                  isRequired
                  label='Admin Username'
                  value={username}
                >
                  <FormControl
                    autoFocus
                    className={styles.usernameField}
                    name='username'
                    onChange={onChange}
                    value={username}
                  />
                  <span className={styles.note}>
                    Only one password reset attempt is allowed per hour
                  </span>
                </FormField>
              </Col>
            </Row>
          </Grid>

          <Row>
            <Col xs={12}>
              <ButtonToolbar
                className={styles.buttons}
              >
                <SubmitButton
                  bsStyle="primary"
                >
                  Next Step
                </SubmitButton>

                <Button
                  href={createLoginLink()}
                  bsStyle="default"
                >
                  Back to Login Page
                </Button>
              </ButtonToolbar>
            </Col>
          </Row>
        </Panel>
        <Captcha
          siteKey={captchaSiteKey}
          callback={onSubmit}
        />
      </Form>
    );
  }
}
UsernameForm.propTypes = {
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  username: PropTypes.string,
  captchaSiteKey: PropTypes.string
};

export default UsernameForm;
